
import * as XLSX from "xlsx";
import * as XlsxPopulate from "xlsx-populate/browser/xlsx-populate";

import { tableHeader, prodReportHeader } from "./PRODWIExcel_Headers";

export async function ExportToExcel(fileName, Data, options) {
  const {
    colwidth,
    titleCell,
    titleWelderRange,
    tbodyHeadRange,
    tbodyRange,
    blankRow,
    Headings,
    sheetName,
    reportName
  } = options;
 
  let bodyRange;

  let wb = XLSX.utils.book_new();
  let data;
  if (reportName === "ProdReport") {
    data = [...prodReportHeader, ...Data];
  } else {
    data = [...tableHeader, ...Data];
  }

  let alldata = [""]
    .concat([""])
    .concat([""])
    .concat([""])
    .concat([""])
    .concat(data);

  let ws = XLSX.utils.json_to_sheet(alldata, { skipHeader: true });
  XLSX.utils.book_append_sheet(wb, ws, sheetName);

  if (reportName === "ProdReport") {
    bodyRange = `${tbodyRange}:R${alldata.length}`;
  } else {
    bodyRange = `${tbodyRange}:L${alldata.length}`;
  }

  const wopts = {
    bookType: "xlsx",
    bookSST: false,
    type: "binary",
  };

  const wbout = XLSX.write(wb, wopts);
  const blob = new Blob([s2ab(wbout)], {
    type: "application/octet-stream",
  });

  const dataInfo1 = {
    titleCell: titleCell,
    titleWelderRange: titleWelderRange,
    tbodyHeadRange: tbodyHeadRange,
    tbodyRange: bodyRange,
    blankRow: blankRow,
  };


  XlsxPopulate.fromDataAsync(blob).then((workbook) => {
    let sheet = workbook.sheets()[0];

    sheet.row(5).style("wrapText", true);

    sheet.gridLinesVisible(false);

    sheet.freezePanes(0, 2);
    for (const col of colwidth) {
      sheet.column(col.col).width(col.width);
    }
    for (const heading of Headings) {
      sheet.cell(heading.col).value(heading.value);
    }

    sheet.range(dataInfo1.titleWelderRange).style({
      bold: true,
      underline: true,
    });

    sheet.range(dataInfo1.tbodyHeadRange).style({
      bold: true,
      horizontalAlignment: "center",
      border: "thin",
    });
    sheet.range(dataInfo1.tbodyRange).style({
      border: "thin",
    });

    return workbook
      .outputAsync()
      .then((workbookBlob) => URL.createObjectURL(workbookBlob))
      .then((url) => {
        const downloadAnchorNode = document.createElement("a");
        downloadAnchorNode.setAttribute("href", url);
        downloadAnchorNode.setAttribute("download", fileName);
        downloadAnchorNode.click();
        downloadAnchorNode.remove();
      });
  });
}

const s2ab = (s) => {

  const buf = new ArrayBuffer(s.length);

  const view = new Uint8Array(buf);
  for (let i = 0; i < s.length; ++i) {
    view[i] = s.charCodeAt(i);
  }
  return buf;
};
